/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "1.5.0",
  "gitBuildTime": "2026-03-26T14:03:14.776Z",
  "gitBuildVersion": "1.5.0",
  "gitCommitId": "e25e4bd",
  "gitCommitIdFull": "e25e4bd0a969b39865c2632e6e6fa861ff2342d3",
  "gitCommitTime": "2026-03-26T13:50:51.000Z",
  "version": "1.5.0-2026-03-26T13:50:51.000Z-(e25e4bd)"
};
